import httpClient from "../../../custom-hooks/httpClient";
import { toast } from "react-toastify";

export const submitDetails = async (photo_url, tid, history) => {
  try {
    const response = await httpClient.post("/verify-user", {
      photo_url: photo_url,
      tid: tid,
    });

    if (response.status === 200) {
      toast.success("Verification process has been successfully completed.");
      history.push("/dashboard");
    }
  } catch (error) {
    console.error("Verification failed!", error);
    toast.error(error.response.data || "Verification Failed!");
  }
};
